const handleShowMoreClick = (paymentMethodList, e) => {
    e.preventDefault();
    paymentMethodList.classList.remove('ternicate-payment-list');
    paymentMethodList.classList.add('tcl-animate-appear-payment-list');
    const showMoreButtonContainer = document.getElementById('tcl-show-more-button');
    showMoreButtonContainer.style.display = 'none'
}

const reshapeLogo = () => {
    return new Promise(resolve => {
        const logoElments = document.querySelectorAll('.compact-logo__retina');
        const parseUrl = /url\(['"]?(.*?)['"]?\)/gi;
        
        if (!logoElments.length) return resolve(true);

        const url = parseUrl.exec(window.getComputedStyle(logoElments[0]).backgroundImage);
        
        if (!url || !url[1]) return resolve(true);

        const img = new Image();
        img.src = url[1];
        img.onload = () => {
            if (img.width) {
                logoElments.forEach(logoEl => {
                    logoEl.style.width = `calc(40px * (${img.width} / ${img.height}))`;
                    logoEl.style.backgroundSize = `calc(40px * (${img.width} / ${img.height})) 40px`;
                });
            }
            resolve(true);
        }
        img.onerror = () => {
            resolve(true);
        }
    })
}

const imitateMC2LoadingTime = () => {
    return new Promise((resolve) => {
    // cleanup ticket https://mollie.atlassian.net/browse/PXP-3077
        setTimeout(() => resolve(), 1000);
    })
}

const removeSkeletonLoader = () => {
    const loadersElments = document.querySelectorAll('.tcl-loading-container');
    if (loadersElments.length) loadersElments.forEach(loader => loader.style.display = 'none')
}

const addShowMoreButton = () => {
    const paymentMethodList = document.getElementById('payment-method-list');
    if (paymentMethodList) {
        const allPaymentMethods = paymentMethodList.querySelectorAll('li');
        const showMoreButtonContainer = document.getElementById('tcl-show-more-button');
        const button = document.querySelector('.tcl-show-more-button');
        if (allPaymentMethods.length > 4 && showMoreButtonContainer && button) {
            showMoreButtonContainer.style.display = 'flex';
            button.addEventListener('click', handleShowMoreClick.bind(null, paymentMethodList))
        }
    }
}

const replaceChevronIcons = () => {
    const oldChevronIcons = document.querySelectorAll('.payment-method-list__chevron');
    const list = [];
    if (oldChevronIcons.length) {
        oldChevronIcons.forEach(icon => {
            icon.style.display = 'none';
            list.push(new Promise((res) => {
                const img = document.createElement('img');
                img.src = '/checkout/v3/images/icons/ui/new-chevron.svg';
                img.height = '20';
                img.width = '20';
                img.onload = () => res()
                img.onerror = () => res()
                icon.parentElement.appendChild(img);
            }))
        })
    }
    return Promise.all(list);
}

const handleAfterDOMReady = async () => {
    const logoReshaped = await reshapeLogo();
    if (logoReshaped) await imitateMC2LoadingTime();
    await replaceChevronIcons();
    addShowMoreButton();
    removeSkeletonLoader();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleAfterDOMReady);
} else {
    handleAfterDOMReady();
}